import List from 'containers/Enquiries/List';
import Edit from 'containers/Enquiries/Edit';
import Create from 'containers/Enquiries/Create';
import Show from 'containers/Enquiries/Show';

export default { List, Edit, Create, Show };
